/* src/app/modules/print-cards/components/cards/backgrounds/business-cards-2x3/glass-house-business-card-stack-background/glass-house-business-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 0.5rem;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=glass-house-business-card-stack-background.component.css.map */
